import { render, staticRenderFns } from "./LottieFoxyWink.vue?vue&type=template&id=4b32f422&scoped=true&"
import script from "./LottieFoxyWink.vue?vue&type=script&lang=js&"
export * from "./LottieFoxyWink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32f422",
  null
  
)

export default component.exports